import type { SessionService } from '@efdigital/ll-addon-auth';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

import Footer from '../components/application/footer.gts';
import Header from '../components/application/header.gts';

export default class ApplicationTemplate extends Component {
  @service declare session: SessionService;

  reload = () => {
    window.location.reload();
  };

  flushAndReload = () => {
    try {
      window.localStorage.clear();
    } catch {
      // Best-effort only; continue so reload still happens.
    }

    try {
      window.sessionStorage.clear();
    } catch {
      // Best-effort only; continue so reload still happens.
    }

    // Clear all cookies for current domain
    document.cookie.split(';').forEach((cookie) => {
      const trimmedCookie = cookie.trim();

      if (!trimmedCookie) {
        return;
      }

      const eqPos = trimmedCookie.indexOf('=');
      const name =
        eqPos > -1 ? trimmedCookie.substring(0, eqPos) : trimmedCookie;

      if (!name) {
        return;
      }

      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
    });
    window.location.reload();
  };

  <template>
    {{pageTitle "Hult Ashridge Admin V2"}}
    {{#if this.session.cached.isAuthenticated}}
      <div
        class="d-flex flex-column mh-dvh-100"
        data-test-app-auth="authenticated"
      >
        <Header />

        <div class="flex-grow-1">
          {{outlet}}
        </div>

        <Footer />
      </div>
    {{else}}
      <div class="container">
        {{#if this.session.cached.isAuthenticating}}
          <div
            class="d-flex justify-content-center"
            data-test-app-auth="authenticating"
          >
            <div class="spinner-grow" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        {{else}}
          <div
            class="row justify-content-center my-5"
            data-test-app-auth="unauthenticated"
          >
            <div class="col-12 col-md-10 col-lg-8 col-xl-6">
              <div class="card shadow rounded-5">
                <div class="card-body p-4 p-md-5">
                  <h1 class="h3 text-center mb-3">Please log in to continue</h1>
                  <p class="text-body-secondary mb-4">
                    You are currently signed out. This could happen if your
                    session has timed out or if the sign-in process was
                    interrupted.
                  </p>

                  <div class="alert alert-warning mb-5" role="alert">
                    Please try logging in again first. If that does not work,
                    clear your session data and try again.
                  </div>

                  <div class="d-grid gap-3">
                    <button
                      class="btn btn-primary btn-lg"
                      type="button"
                      {{on "click" this.reload}}
                    >Log in</button>
                    <button
                      class="btn btn-outline-primary btn-sm mx-5"
                      type="button"
                      {{on "click" this.flushAndReload}}
                    >Clear session data and reload</button>
                    <p class="mt-4 mb-0 small text-center">
                      Need help or have feedback? Email
                      <a
                        href="mailto:engineering.team@hultashridge.com"
                      >engineering.team@hultashridge.com</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        {{/if}}
      </div>
    {{/if}}
    <div id="ember-bootstrap-wormhole"></div>
  </template>
}
